import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("sd_token");
        const userJson = localStorage.getItem("sd_user");
        if (token && userJson) {
            try {
                setUser(JSON.parse(userJson));
            } catch (_) {}
        }
        setLoading(false);
    }, []);

    const login = async (email, password) => {
        const { data } = await api.post("/auth/login", { email, password });
        localStorage.setItem("sd_token", data.token);
        localStorage.setItem("sd_user", JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    };

    const register = async (payload) => {
        const { data } = await api.post("/auth/register", payload);
        localStorage.setItem("sd_token", data.token);
        localStorage.setItem("sd_user", JSON.stringify(data.user));
        setUser(data.user);
        return data.user;
    };

    // Used by magic-link verify page — sets an already-issued JWT without
    // re-posting credentials.
    const loginWithToken = (token, userDoc) => {
        localStorage.setItem("sd_token", token);
        localStorage.setItem("sd_user", JSON.stringify(userDoc));
        setUser(userDoc);
        return userDoc;
    };

    const logout = () => {
        localStorage.removeItem("sd_token");
        localStorage.removeItem("sd_user");
        localStorage.removeItem("renforteo_devis_draft_v1");
        setUser(null);
    };

    return (
        <AuthContext.Provider
            value={{ user, loading, login, register, logout, loginWithToken }}
        >
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
